import React from 'react';

import { Button, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FontAwesomeSvgIcon } from '../components/FontAwesomeSvgIcon';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { SettingBar } from './SettingBar';
import { MaptypeBar } from './MaptypeBar';
import { useTranslation } from 'react-i18next';
import { LegendContentControl } from './LegendContent';

const SectionSelect = ({children, label, styles}) => {
  return (
    <Box sx={{display: 'flex',  minHeight: 'max-content'}}>
      <Stack direction ='column'>
        {label && <Typography sx={styles.labelText}>
          {label}
        </Typography>}
        <Box sx={styles.layerSection}>{children}</Box>
      </Stack>
    </Box>
  );
};

export const SettingLayers = ({onClose, isMobile, convertProfiltForApi}) => {
  const styles = {
    layers: {
      display: 'flex',
      paddingX: '1em',
      '&::-webkit-scrollbar': {
        width: '8px'
      }, 
      '&::-webkit-scrollbar-track': {
        width: '4px',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '0.5em',
        backgroundColor: 'gray'
      }
    },
    titleText: {
      fontSize: '1em',
      fontWeight: '700'
    },
    labelText: {
      color: '#666666',
      fontWeight: 'bold'
    },
    closeButton: {
      color: 'black',
      padding: '0px'
    },
    layerSection: {
      display: 'flex',
    },
    checkboxSection : {
      display: 'flex',
      width: isMobile ? '90%' : '100%',
      height: '4em',
      paddingY: '0.75em',
      borderRadius: '0.5em',
      alignItems: 'center'
    },
    checkbox: {
      display: 'flex',
      width: '15%',
      justifyContent: 'center',
      alignItems: 'center'
    },
    textCheckbox: {
      display: 'flex',
      width: '85%',
      justifyContent: 'center',
      alignItems: 'center'
    },
  };

  const {t} = useTranslation();
    
  return (
    <Box sx={styles.layers}>
      {isMobile ? (
        <Stack sx={{display: 'flex', width: '100%',}} direction='column' spacing={5}>
          <Box sx={{
            display: 'flex', 
            width: '90%',
            position: 'fixed',
            zIndex: 100,
            backgroundColor: 'white',
            paddingY: '1em'
          }}>
            <Box sx={{display: 'flex', width: '90%'}}> 
              <Typography id='modal-zone-title' component="h1" sx={styles.titleText}>{t('layer.setting-label')}</Typography>
            </Box>
            <Box sx={{display: 'flex'}}>
              <Button id='layer_settings_close' aria-label={t('layer.close')} sx={styles.closeButton} variant='text' onClick={onClose}>
                <FontAwesomeSvgIcon icon={faTimes} />
              </Button>
            </Box>
          </Box>
          <Box sx={{display: 'flex', marginTop: '2em'}}/>
          <SectionSelect styles={styles} label={t('layer.layer-label')}>
            <SettingBar direction='column' />
          </SectionSelect>
          <SectionSelect styles={styles} label={t('layer.type-label')}>
            <MaptypeBar direction='row'/>
          </SectionSelect>
          <SectionSelect styles={styles} label={t('legend.title')}>
            <LegendContentControl isMobile={isMobile} convertProfiltForApi={convertProfiltForApi}/>
          </SectionSelect>
          
        </Stack>
      ) : 
        (
          <Stack sx={{display: 'flex', width: '100%',  paddingY: '1em'}} direction='column' spacing={2}>
            <Box sx={{display: 'flex', width: '100%'}}>
              <Box sx={{display: 'flex', width: '90%'}}>
                <Typography id='modal-zone-title' component="h1" sx={styles.titleText}>{t('layer.layer-label')}</Typography>
              </Box>
              <Box sx={{display: 'flex'}}>
                <Button id='layer_settings_close' aria-label={t('layer.close')} sx={styles.closeButton} variant='text' onClick={onClose}>
                  <FontAwesomeSvgIcon icon={faTimes} />
                </Button>
              </Box>
            </Box>
            <SectionSelect styles={styles}>
              <SettingBar direction='column' />
            </SectionSelect>
          </Stack>
        )}
    </Box>
  );
};